import PaletteProps from './PaletteProps';
import values from './values-dm';

const paletteDmWeb: PaletteProps = {
  ...values,
  get headline() {
    return {
      hex: values.color2.hex,
    };
  },
  get text() {
    return {
      hex: values.color3.hex,
    };
  },
  get background() {
    return {
      hex: values.color5.hex,
    };
  },
  get backgroundAlternative() {
    return {
      hex: values.color9.hex,
    };
  },
  get backgroundInfo() {
    return {
      hex: values.color4.hex,
    };
  },
  get backgroundSuccess() {
    return {
      hex: values.color11.hex,
    };
  },
  get backgroundWarning() {
    return {
      hex: values.color12.hex,
    };
  },
  get backgroundError() {
    return {
      hex: values.color13.hex,
    };
  },
  get border() {
    return {
      hex: values.color4.hex,
    };
  },
  get icon() {
    return {
      hex: values.color2.hex,
    };
  },
  get cta() {
    return {
      hex: values.color2.hex,
    };
  },
  get inactive() {
    return {
      hex: values.color10.hex,
    };
  },
  get success() {
    return {
      hex: values.color6.hex,
    };
  },
  get warning() {
    return {
      hex: values.color7.hex,
    };
  },
  get error() {
    return {
      hex: values.color8.hex,
    };
  },
};

export default paletteDmWeb;
